import json from "../json/maintenanceStatus.json";

export default async () => JSON.parse(JSON.stringify(await json));
